module.exports = __webpack_public_path__ + "img/3.0f3b6bdf.png";